import type { ConversationSummary } from '@/hooks/use-agent-chat.hook';

/**
 * Resolve the label for the active conversation: its saved title, else the
 * first user message (truncated), else "New chat". Shared by every surface
 * that renders the conversation switcher (docked sidebar header, Copilot-home
 * top bar) so the active-conversation label reads identically everywhere.
 */
export function getConversationLabel({
  conversationId,
  conversations,
  messages,
}: {
  conversationId: string | null;
  conversations: ConversationSummary[];
  messages: { role: 'user' | 'assistant'; content: string }[];
}): string {
  const activeConversation = conversations.find(
    (conversation) => conversation.id === conversationId
  );

  if (activeConversation?.title) {
    return activeConversation.title;
  }

  const firstUserMessage = messages.find((message) => message.role === 'user');
  if (firstUserMessage?.content) {
    return firstUserMessage.content.slice(0, 48);
  }

  return 'New chat';
}
